// -----------------------------------------------------------------------------------------------------------------
// Restricted - Copyright (C) Siemens Healthineers AG 2023.
// -----------------------------------------------------------------------------------------------------------------
/**
 * ShuiEvent event class for our CustomEvent replacement to work with the shui/check-events eslint rule
 */
export class ShuiEvent extends CustomEvent {
  constructor(prop, init) {
    super(`${prop}`, init);
  }
}
/**
 * All the non-legacy events ordered alphabetically
 */
export class ActiveChangedEvent extends ShuiEvent {
  constructor(init) {
    super('active-changed', init);
  }
}
export class ApplyFirstSelectionEvent extends ShuiEvent {
  constructor(init) {
    super('apply-first-selection', init);
  }
}
export class ArrowPartClickEvent extends ShuiEvent {
  constructor(init) {
    super('arrow-part-click', init);
  }
}
export class ButtonPartClickEvent extends ShuiEvent {
  constructor(init) {
    super('button-part-click', init);
  }
}
export class CalendarClosedEvent extends ShuiEvent {
  constructor(init) {
    super('calendar-closed', init);
  }
}
export class CheckedEvent extends ShuiEvent {
  constructor(init) {
    super('checked', init);
  }
}
export class ClearSearchEvent extends ShuiEvent {
  constructor(init) {
    super('clearsearch', init);
  }
}
export class ClearClickedEvent extends ShuiEvent {
  constructor(init) {
    super('clear-clicked', init);
  }
}
export class ClickedEvent extends ShuiEvent {
  constructor(init) {
    super('clicked', init);
  }
}
export class ClickedPageMoveEvent extends ShuiEvent {
  constructor(init) {
    super('clicked-page-move', init);
  }
}
export class CloseEvent extends ShuiEvent {
  constructor(init) {
    super('close', init);
  }
}
export class ClosePressedEvent extends ShuiEvent {
  constructor(init) {
    super('close-pressed', init);
  }
}
export class ClosedEvent extends ShuiEvent {
  constructor(init) {
    super('closed', init);
  }
}
export class ClosingEvent extends ShuiEvent {
  constructor(init) {
    super('closing', init);
  }
}
export class CollapseEvent extends ShuiEvent {
  constructor(init) {
    super('collapse', init);
  }
}
export class ControlValueChangeEvent extends ShuiEvent {
  constructor(init) {
    super('control-value-change', init);
  }
}
export class DrawerClosedEvent extends ShuiEvent {
  constructor(init) {
    super('drawer-closed', init);
  }
}
export class ExpandEvent extends ShuiEvent {
  constructor(init) {
    super('expand', init);
  }
}
export class FullscreenToggleEvent extends ShuiEvent {
  constructor(init) {
    super('fullscreen-toggle', init);
  }
}
export class HeadReadyEvent extends ShuiEvent {
  constructor(init) {
    super('head-ready', init);
  }
}
export class HintClickedEvent extends ShuiEvent {
  constructor(init) {
    super('hint-clicked', init);
  }
}
export class InputClickedEvent extends ShuiEvent {
  constructor(init) {
    super('input-clicked', init);
  }
}
export class InputFocusedEvent extends ShuiEvent {
  constructor(init) {
    super('input-focused', init);
  }
}
export class InputHoverEvent extends ShuiEvent {
  constructor(init) {
    super('input-hover', init);
  }
}
export class ItemActiveEvent extends ShuiEvent {
  constructor(init) {
    super('item-active', init);
  }
}
export class KeypadClosedEvent extends ShuiEvent {
  constructor(init) {
    super('keypad-closed', init);
  }
}
export class KeypadOpenedEvent extends ShuiEvent {
  constructor(init) {
    super('keypad-opened', init);
  }
}
export class KeyPressEvent extends ShuiEvent {
  constructor(init) {
    super('key-press', init);
  }
}
export class LabelHoverEvent extends ShuiEvent {
  constructor(init) {
    super('label-hover', init);
  }
}
export class LeftArrowClickEvent extends ShuiEvent {
  constructor(init) {
    super('left-arrow-click', init);
  }
}
export class LogoClickedEvent extends ShuiEvent {
  constructor(init) {
    super('logo-clicked', init);
  }
}
export class MaximizePressedEvent extends ShuiEvent {
  constructor(init) {
    super('maximize-pressed', init);
  }
}
export class MenuClickedEvent extends ShuiEvent {
  constructor(init) {
    super('menu-clicked', init);
  }
}
export class MenuItemActiveEvent extends ShuiEvent {
  constructor(init) {
    super('menu-item-active', init);
  }
}
export class MiddleScrolledEvent extends ShuiEvent {
  constructor(init) {
    super('middle-scrolled', init);
  }
}
export class MinimizePressedEvent extends ShuiEvent {
  constructor(init) {
    super('minimize-pressed', init);
  }
}
// does not follow kebab-case but needs to be there for backwards compatibility
export class MinusPressedEvent extends ShuiEvent {
  constructor(init) {
    super('minusPressed', init);
  }
}
// does not follow kebab-case but needs to be there for backwards compatibility
export class PlusPressedEvent extends ShuiEvent {
  constructor(init) {
    super('plusPressed', init);
  }
}
export class ModalClosedEvent extends ShuiEvent {
  constructor(init) {
    super('modal-closed', init);
  }
}
export class MonthClickedEvent extends ShuiEvent {
  constructor(init) {
    super('month-clicked', init);
  }
}
export class MonthHeaderClickedEvent extends ShuiEvent {
  constructor(init) {
    super('month-header-clicked', init);
  }
}
export class NextPageMoveEvent extends ShuiEvent {
  constructor(init) {
    super('next-page-move', init);
  }
}
export class NoresultEvent extends ShuiEvent {
  constructor(init) {
    super('noresult', init);
  }
}
export class OverlayClosedEvent extends ShuiEvent {
  constructor(init) {
    super('overlay-closed', init);
  }
}
export class PreviousPageMoveEvent extends ShuiEvent {
  constructor(init) {
    super('previous-page-move', init);
  }
}
export class ReadyToUpdateValueEvent extends ShuiEvent {
  constructor(init) {
    super('ready-to-update-value', init);
  }
}
export class RightArrowClickEvent extends ShuiEvent {
  constructor(init) {
    super('right-arrow-click', init);
  }
}
export class ProgressChangedEvent extends ShuiEvent {
  constructor(init) {
    super('progress-changed', init);
  }
}
export class ScrollChangedEvent extends ShuiEvent {
  constructor(init) {
    super('scroll-changed', init);
  }
}
export class ScrollEndEvent extends ShuiEvent {
  constructor(init) {
    super('scroll-end', init);
  }
}
export class TableScrollEvent extends ShuiEvent {
  constructor(init) {
    super('table-scroll', init);
  }
}
export class ScrollpickerClosedEvent extends ShuiEvent {
  constructor(init) {
    super('scrollpicker-closed', init);
  }
}
export class SearchEvent extends ShuiEvent {
  constructor(init) {
    super('search', init);
  }
}
export class SelectedDatesChangedEvent extends ShuiEvent {
  constructor(init) {
    super('selected-dates-changed', init);
  }
}
export class ShowArrowEvent extends ShuiEvent {
  constructor(init) {
    super('showarrow', init);
  }
}
export class SkipBackClickedEvent extends ShuiEvent {
  constructor(init) {
    super('skip-back-clicked', init);
  }
}
export class SkipForwardClickedEvent extends ShuiEvent {
  constructor(init) {
    super('skip-forward-clicked', init);
  }
}
export class SlotsModifiedEvent extends ShuiEvent {
  constructor(init) {
    super('slots-modified', init);
  }
}
export class ToggleEvent extends ShuiEvent {
  constructor(init) {
    super('toggle', init);
  }
}
export class TimeClickedEvent extends ShuiEvent {
  constructor(init) {
    super('time-clicked', init);
  }
}
export class ValuesChangedEvent extends ShuiEvent {
  constructor(init) {
    super('values-changed', init);
  }
}
export class WorklineAnimationEndedEvent extends ShuiEvent {
  constructor(init) {
    super('workline-animation-ended', init);
  }
}
export class WorklineItemFloatChangedEvent extends ShuiEvent {
  constructor(init) {
    super('workline-item-float-changed', init);
  }
}
export class WorklineItemSizeChangedEvent extends ShuiEvent {
  constructor(init) {
    super('workline-item-size-changed', init);
  }
}
export class YearClickedEvent extends ShuiEvent {
  constructor(init) {
    super('year-clicked', init);
  }
}
export class YearHeaderClickedEvent extends ShuiEvent {
  constructor(init) {
    super('year-header-clicked', init);
  }
}
export class OnSelectEvent extends ShuiEvent {
  constructor(init) {
    super('on-select', init);
  }
}
export class ActionClickedEvent extends ShuiEvent {
  constructor(init) {
    super('action-clicked', init);
  }
}
export class DismissedEvent extends ShuiEvent {
  constructor(init) {
    super('dismissed', init);
  }
}
export class ShownEvent extends ShuiEvent {
  constructor(init) {
    super('shown', init);
  }
}
export class ChangeEndEvent extends CustomEvent {
  constructor(prop, init) {
    super(`${prop}`, init);
  }
}
export class ControlValueChangeEndEvent extends ChangeEndEvent {
  constructor(init) {
    super('control-value-change-end', init);
  }
}
export class RangeValueChangeEndEvent extends ChangeEndEvent {
  constructor(init) {
    super('range-value-change-end', init);
  }
}
export class ValueChangeEndEvent extends ChangeEndEvent {
  constructor(init) {
    super('value-change-end', init);
  }
}
/**
 * Base event class for our legacy propXYZ-changed events
 */
export class LegacyPropertyChangedEvent extends CustomEvent {
  constructor(prop, init) {
    super(`${prop}-changed`, init);
  }
}
/**
 * All the legacy events ordered alphabetically
 * the event name gets post-fixed by -changed
 */
export class DisabledPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor(init) {
    super('disabled', init);
  }
}
export class IconPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('icon');
  }
}
export class LabelPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('label');
  }
}
export class SizePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('size');
  }
}
export class ColorPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('color');
  }
}
export class TooltipPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('tooltip');
  }
}
export class HrefPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('href');
  }
}
export class DragAndDropPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('drag-and-drop');
  }
}
export class IconColorPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('icon-color');
  }
}
export class HeaderPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('header');
  }
}
export class ButtonPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('button');
  }
}
export class BadgePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('badge');
  }
}
export class TogglePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('toggle');
  }
}
export class StickyPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('sticky');
  }
}
export class TitlePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('title');
  }
}
export class VariationPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('variation');
  }
}
export class TargetPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('target');
  }
}
export class NumberPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('number');
  }
}
export class VisiblePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('visible');
  }
}
export class TypePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('type');
  }
}
export class ModalHeightPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('modal-height');
  }
}
export class ModalWidthPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('modal-width');
  }
}
export class PagesPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('pages');
  }
}
export class CurrentPagePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('current-page');
  }
}
export class SpacingPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('spacing');
  }
}
export class VariantPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('variant');
  }
}
export class VerticalPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('vertical');
  }
}
export class IndeterminatePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('indeterminate');
  }
}
export class NeutralPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('neutral');
  }
}
export class HintPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('hint');
  }
}
export class ErrorMessagePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('error-message');
  }
}
export class MultiSelectPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('multi-select');
  }
}
export class NoBorderPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('no-border');
  }
}
export class MandatoryPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('mandatory');
  }
}
export class SuccessPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('success');
  }
}
export class SafetyPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('safety');
  }
}
export class EditablePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('editable');
  }
}
export class ValuePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor(init) {
    super('value', init);
  }
}
export class MultilinePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('multiline');
  }
}
export class FieldsPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('fields');
  }
}
export class SrcPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('src');
  }
}
export class PlacementPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('placement');
  }
}
export class ErrorPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('error');
  }
}
export class ImagePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('image');
  }
}
export class LabelAlignmentPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('label-alignment');
  }
}
export class OverlayPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('overlay');
  }
}
export class PausedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('paused');
  }
}
export class RadialPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('radial');
  }
}
export class StatusPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('status');
  }
}
export class InfoPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('info');
  }
}
export class ModalPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('modal');
  }
}
export class ProgressPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('progress');
  }
}
export class SubHeadlinePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('sub-headline');
  }
}
export class VersionPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('version');
  }
}
export class NoClearPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('no-clear');
  }
}
export class ActivePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('active');
  }
}
export class CurrentPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('current');
  }
}
export class DecimalsPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('decimals');
  }
}
export class EuropeanNumberConventionPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('european-number-convention');
  }
}
export class ReadonlyPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('readonly');
  }
}
export class MessageVisiblePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('message-visible');
  }
}
export class ThumbnailPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('thumbnail');
  }
}
export class FlatPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('flat');
  }
}
export class ExpandedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('expanded');
  }
}
export class MessagePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('message');
  }
}
export class VisualFocusPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('visual-focus');
  }
}
export class SelectablePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('selectable');
  }
}
export class NewPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('new');
  }
}
export class SubMenuPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('sub-menu');
  }
}
export class PositionPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('position');
  }
}
export class PassivePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('passive');
  }
}
export class MobilePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('mobile');
  }
}
export class MiniPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('mini');
  }
}
export class CheckedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('checked');
  }
}
export class OptionsPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('options');
  }
}
export class CollapsedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('collapsed');
  }
}
export class CondensedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('condensed');
  }
}
export class NativePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('native');
  }
}
export class EmbeddedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('embedded');
  }
}
export class TextareaPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('textarea');
  }
}
export class ResizablePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('resizable');
  }
}
export class CardHeightPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('card-height');
  }
}
export class ArrowPositionPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('arrow-position');
  }
}
export class BehaviorPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('behavior');
  }
}
export class StretchPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('stretch');
  }
}
export class HPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('h');
  }
}
export class MPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('m');
  }
}
export class SPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('s');
  }
}
export class MeridiemPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('am-pm');
  }
}
export class AmPmPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('am-pm');
  }
}
export class StepPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('step');
  }
}
export class ClockFormatPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('clock-format');
  }
}
export class ValPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('val');
  }
}
export class TimeValueChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('time-value');
  }
}
export class CurrentActivePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('current-active');
  }
}
export class CurrentSelectedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('current-selected');
  }
}
export class DrawerWidthPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('drawer-width');
  }
}
export class AspectRatioPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('aspect-ratio');
  }
}
export class MinPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('min');
  }
}
export class MaxPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('max');
  }
}
export class KeypadPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('keypad');
  }
}
export class NoArrowsPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('no-arrows');
  }
}
export class InputDisabledPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('input-disabled');
  }
}
export class KeypadActivePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('keypad-active');
  }
}
export class KeypadDisabledPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('keypad-disabled');
  }
}
export class NoValidatePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('no-validate');
  }
}
export class FixedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('fixed');
  }
}
export class InitialsPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('initials');
  }
}
export class NamePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('name');
  }
}
export class PatientPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('patient');
  }
}
export class ShowControlsPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('show-controls');
  }
}
export class ShowRangePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('show-range');
  }
}
export class LowerValuePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor(init) {
    super('lower-value', init);
  }
}
export class UpperValuePropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor(init) {
    super('upper-value', init);
  }
}
export class UnauthenticatedPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('unauthenticated');
  }
}
export class BackgroundPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('background');
  }
}
export class PaddingPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('padding');
  }
}
export class ElevationPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('elevation');
  }
}
export class ContentGapPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('content-gap');
  }
}
export class LayoutPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('layout');
  }
}
export class ActiveRegionsPropertyChangedEvent extends LegacyPropertyChangedEvent {
  constructor() {
    super('active-regions');
  }
}
